import React, { Component } from "react";
import { translate } from "react-i18next";
import compose from "ramda/src/compose";

import { Modal, Button } from "shared/components";

import IconCalendar from "../../../../assets/svg/calendar_white.svg";
import styles from "./styles.css";

class ReOpenSolicitationModal extends Component {
  render() {
    const { t, isOpen, message, onClose, onCreateIncident } = this.props;

    return (
      <Modal
        icon={IconCalendar}
        title={t("MSG_0293")}
        isOpen={isOpen}
        onClose={onClose}
        noOverflow={true}
      >
        <div className={styles.details}>{message}</div>

        <hr />

        <div className={styles.action}>
          <Button relevance="low" type="submit" callToAction weight="thin">
            {t("MSG_0292")}
          </Button>
          <Button
            relevance="normal"
            type="submit"
            callToAction
            weight="thin"
            onClick={() => {
              onClose();
              onCreateIncident();
            }}
          >
            {t("MSG_0241")}
          </Button>
        </div>
      </Modal>
    );
  }
}

const enhance = compose(translate());

export default enhance(ReOpenSolicitationModal);



// WEBPACK FOOTER //
// ./src/scenes/IncidentManager/components/ReOpenSolicitationModal/index.js